// Client-side rate limiting using localStorage
// NOTE: This can be bypassed by tech-savvy users, but works for a prototype

const STORAGE_KEY = 'saheehAI_rateLimit';
const DAILY_LIMIT = 50;

class RateLimitService {
  getCurrentDate() {
    return new Date().toISOString().split('T')[0]; // YYYY-MM-DD
  }

  getRateLimitData() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (!data) {
        return { date: this.getCurrentDate(), count: 0 };
      }
      return JSON.parse(data);
    } catch (error) {
      console.error('Error reading rate limit data:', error);
      return { date: this.getCurrentDate(), count: 0 };
    }
  }

  saveRateLimitData(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving rate limit data:', error);
    }
  }

  checkAndIncrement() {
    const today = this.getCurrentDate();
    const data = this.getRateLimitData();

    // Reset counter if it's a new day
    if (data.date !== today) {
      data.date = today;
      data.count = 0;
    }

    // Check if limit exceeded
    if (data.count >= DAILY_LIMIT) {
      return {
        allowed: false,
        remaining: 0,
        count: data.count,
        limit: DAILY_LIMIT
      };
    }

    // Increment counter
    data.count++;
    this.saveRateLimitData(data);

    return {
      allowed: true,
      remaining: DAILY_LIMIT - data.count,
      count: data.count,
      limit: DAILY_LIMIT
    };
  }

  rollback() {
    const data = this.getRateLimitData();
    if (data.count > 0) {
      data.count--;
      this.saveRateLimitData(data);
    }
  }

  getStatus() {
    const today = this.getCurrentDate();
    const data = this.getRateLimitData();

    // Reset if it's a new day
    if (data.date !== today) {
      return {
        count: 0,
        remaining: DAILY_LIMIT,
        limit: DAILY_LIMIT
      };
    }

    return {
      count: data.count,
      remaining: DAILY_LIMIT - data.count,
      limit: DAILY_LIMIT
    };
  }

  reset() {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export default new RateLimitService();
